(function () {
  if (window.tpaDeliveryLoaded) return;
  window.tpaDeliveryLoaded = true;

  // ── Shipping config ──────────────────────────────────────────────────────
  // freeShippingCents: threshold (in minor currency units) above which shipping is free.
  // null = no free shipping offered. Override per region as rules evolve.
  var REGIONS = {
    NL: { min: 1, max: 1, cutoff: 23 * 60 + 59, freeShippingCents: 4000 },
    BE: { min: 1, max: 1, cutoff: 22 * 60,      freeShippingCents: 4000 },
    DE: { min: 2, max: 3, cutoff: 22 * 60,      freeShippingCents: 4000 }
  };
  var EU_FALLBACK = { min: 2, max: 5, cutoff: 22 * 60, freeShippingCents: 4000 };
  var EU_COUNTRIES = new Set([
    'AT','BG','CY','CZ','DK','EE','ES','FI','FR','GR',
    'HR','HU','IE','IT','LT','LU','LV','MT','PL','PT','RO','SE','SI','SK'
  ]);

  // ── NL public holidays (blocks dispatch) ────────────────────────────────
  var NL_HOLIDAYS = new Set([
    // 2025
    '2025-01-01','2025-04-18','2025-04-20','2025-04-21',
    '2025-04-26','2025-05-05','2025-05-29','2025-06-08',
    '2025-06-09','2025-12-25','2025-12-26',
    // 2026
    '2026-01-01','2026-04-03','2026-04-05','2026-04-06',
    '2026-04-27','2026-05-05','2026-05-14','2026-05-24',
    '2026-05-25','2026-12-25','2026-12-26',
    // 2027
    '2027-01-01','2027-03-26','2027-03-28','2027-03-29',
    '2027-04-27','2027-05-05','2027-05-06','2027-05-16',
    '2027-05-17','2027-12-25','2027-12-26'
  ]);

  // ── Date helpers ─────────────────────────────────────────────────────────
  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function toKey(date) {
    return date.getFullYear() + '-' + pad(date.getMonth() + 1) + '-' + pad(date.getDate());
  }

  function nowInAmsterdam() {
    var parts = {};
    new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Amsterdam',
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', hour12: false
    }).formatToParts(new Date()).forEach(function (p) {
      parts[p.type] = p.value;
    });
    return {
      year: parseInt(parts.year, 10),
      month: parseInt(parts.month, 10) - 1,
      day: parseInt(parts.day, 10),
      minuteOfDay: parseInt(parts.hour, 10) * 60 + parseInt(parts.minute, 10)
    };
  }

  function dateFromAmsterdam(ams) {
    return new Date(ams.year, ams.month, ams.day);
  }

  function isNLHoliday(date) { return NL_HOLIDAYS.has(toKey(date)); }
  function isWeekday(date) { var d = date.getDay(); return d >= 1 && d <= 5; }
  function isBusinessDay(date) { return isWeekday(date) && !isNLHoliday(date); }

  function nextBusinessDay(date) {
    var d = new Date(date);
    do { d.setDate(d.getDate() + 1); } while (!isBusinessDay(d));
    return d;
  }

  function addBusinessDays(date, n) {
    var d = new Date(date);
    var added = 0;
    while (added < n) {
      d.setDate(d.getDate() + 1);
      if (isWeekday(d)) added++;
    }
    return d;
  }

  // ── Formatting ───────────────────────────────────────────────────────────
  var ORDINAL_SUFFIXES = { one: 'st', two: 'nd', few: 'rd', other: 'th' };
  var ordinalRules = typeof Intl !== 'undefined' && Intl.PluralRules
    ? new Intl.PluralRules('en', { type: 'ordinal' }) : null;

  function ordinalSuffix(n) {
    if (!ordinalRules) return '';
    return ORDINAL_SUFFIXES[ordinalRules.select(n)] || 'th';
  }

  function formatDate(date, today, lang) {
    var strings = window.tpaDeliveryStrings || {};
    var diffDays = Math.round((date - today) / 86400000);
    if (diffDays === 0 && strings.today)    return strings.today;
    if (diffDays === 1 && strings.tomorrow) return strings.tomorrow;
    var l = lang || 'en';
    if (l === 'en' || l.indexOf('en-') === 0) {
      var weekday = new Intl.DateTimeFormat('en', { weekday: 'long' }).format(date);
      var month   = new Intl.DateTimeFormat('en', { month: 'long' }).format(date);
      var day     = date.getDate();
      return weekday + ', ' + month + ' ' + day + ordinalSuffix(day);
    }
    return new Intl.DateTimeFormat(l, {
      weekday: 'long', day: 'numeric', month: 'long'
    }).format(date);
  }

  function formatCutoff(minuteOfDay) {
    return pad(Math.floor(minuteOfDay / 60)) + ':' + pad(minuteOfDay % 60);
  }

  function formatMoney(cents, currency, lang) {
    var amount = (cents || 0) / 100;
    try {
      var opts = { style: 'currency', currency: currency || 'EUR' };
      // Whole amounts look cleaner without decimals (€40 rather than €40.00).
      if (amount === Math.floor(amount)) {
        opts.minimumFractionDigits = 0;
        opts.maximumFractionDigits = 0;
      }
      return new Intl.NumberFormat(lang || 'en', opts).format(amount);
    } catch (e) {
      return '€' + amount;
    }
  }

  // ── Pre-order state toggle ───────────────────────────────────────────────
  function updateDeliveryState(el) {
    var managed  = el.dataset.inventoryManagement === 'shopify';
    var qty      = parseInt(el.dataset.inventoryQuantity, 10);
    var policy   = el.dataset.inventoryPolicy;
    var isPreorder = managed && qty <= 0 && policy === 'continue';
    // Use data-available as primary signal (set by Liquid on render, synced from variant:update)
    var isAvailable = el.dataset.available !== 'false';

    var instockEl   = el.querySelector('[data-tpa-state="instock"]');
    var preorderEl  = el.querySelector('[data-tpa-state="preorder"]');
    var outofstockEl = el.querySelector('[data-tpa-state="outofstock"]');

    if (instockEl)    instockEl.hidden    = isPreorder || !isAvailable;
    if (preorderEl)   preorderEl.hidden   = !isPreorder;
    if (outofstockEl) outofstockEl.hidden = isAvailable;

    // Populate translated pre-order label text
    if (preorderEl) {
      var strings = window.tpaDeliveryStrings || {};
      var labelEl    = preorderEl.querySelector('.tpa-delivery__preorder-label');
      var expectedEl = preorderEl.querySelector('.tpa-delivery__preorder-expected');
      if (labelEl)    labelEl.textContent    = strings.preOrder    || 'Pre-order';
      if (expectedEl) expectedEl.textContent = (strings.preorderExpected || 'Expected') + ': ';
    }
  }

  // ── Main renderer ────────────────────────────────────────────────────────
  function renderAll() {
    var lang = document.documentElement.lang || 'en';
    var ams  = nowInAmsterdam();
    var today = dateFromAmsterdam(ams);
    var strings = window.tpaDeliveryStrings || {};

    document.querySelectorAll('[data-tpa-delivery]').forEach(function (el) {
      updateDeliveryState(el);

      var iso = (el.dataset.country || '').toUpperCase();
      var region = REGIONS[iso] || (EU_COUNTRIES.has(iso) ? EU_FALLBACK : null);
      if (!region) return;

      var shipsToday = isBusinessDay(today) && ams.minuteOfDay < region.cutoff;
      var shipDate   = shipsToday ? today : nextBusinessDay(today);

      var arriveMin = addBusinessDays(shipDate, region.min);
      var arriveMax = addBusinessDays(shipDate, region.max);

      var arriveStr = region.min === region.max
        ? formatDate(arriveMin, today, lang)
        : formatDate(arriveMin, today, lang) + ' – ' + formatDate(arriveMax, today, lang);

      var suffix = (strings.deliverySuffix || '').trim();
      var deliveryPart = (strings.deliveredBy || 'Delivered by') + ' ' + arriveStr
                       + (suffix ? ' ' + suffix : '');
      var text;
      if (shipsToday) {
        var cutoffStr = formatCutoff(region.cutoff);
        text = (strings.orderBefore || 'Order before') + ' ' + cutoffStr
             + ' · ' + deliveryPart;
      } else {
        text = deliveryPart;
      }

      var lineEl = el.querySelector('.tpa-delivery__text');
      if (lineEl) lineEl.textContent = text;

      // ── Free shipping line ───────────────────────────────────────
      var shippingEl = el.querySelector('[data-tpa-shipping]');
      if (shippingEl) {
        var priceCents = parseInt(el.dataset.variantPrice, 10);
        var currency = el.dataset.currency || 'EUR';
        var threshold = region.freeShippingCents;

        if (threshold == null || isNaN(priceCents)) {
          shippingEl.hidden = true;
        } else if (priceCents >= threshold) {
          shippingEl.hidden = false;
          shippingEl.classList.add('tpa-delivery__shipping--eligible');
          var textEl = shippingEl.querySelector('.tpa-delivery__shipping-text');
          if (textEl) textEl.textContent = strings.freeShippingEligible || 'Free shipping included';
        } else {
          shippingEl.hidden = false;
          shippingEl.classList.remove('tpa-delivery__shipping--eligible');
          var textEl2 = shippingEl.querySelector('.tpa-delivery__shipping-text');
          if (textEl2) {
            var template = strings.freeShippingThreshold || 'Free shipping over {{ amount }}';
            textEl2.textContent = template.replace('{{ amount }}', formatMoney(threshold, currency, lang));
          }
        }
      }
    });
  }

  function handleVariantUpdate(e) {
    var variant = e && e.detail && e.detail.resource;
    var newHtml = e && e.detail && e.detail.data && e.detail.data.html;

    document.querySelectorAll('[data-tpa-delivery]').forEach(function (el) {
      // Primary: read from the freshly Liquid-rendered HTML fragment — has all fields including
      // inventory_policy and inventory_quantity which are absent from the event's variant object.
      if (newHtml) {
        var newEl = newHtml.querySelector('[data-tpa-delivery]');
        if (newEl) {
          ['available', 'inventoryPolicy', 'inventoryQuantity', 'inventoryManagement',
           'variantPrice', 'preorderDate'].forEach(function (key) {
            if (newEl.dataset[key] !== undefined) el.dataset[key] = newEl.dataset[key];
          });
          return;
        }
      }
      // Fallback: partial update from the event variant object (inventory_policy / quantity absent)
      if (variant) {
        if (variant.price != null)                el.dataset.variantPrice         = String(variant.price);
        if (variant.available != null)            el.dataset.available            = String(variant.available);
        if (variant.inventory_policy != null)     el.dataset.inventoryPolicy      = variant.inventory_policy;
        if (variant.inventory_quantity != null)   el.dataset.inventoryQuantity    = String(variant.inventory_quantity);
        if (variant.inventory_management != null) el.dataset.inventoryManagement  = variant.inventory_management;
      }
    });

    renderAll();
  }

  document.addEventListener('DOMContentLoaded', renderAll);
  document.addEventListener('variant:update', handleVariantUpdate);
})();
